__turbopack_context__.v({
  "authButton": "Auth-module-scss-module__SZrH2a__authButton",
  "authIcon": "Auth-module-scss-module__SZrH2a__authIcon",
  "header-container": "Auth-module-scss-module__SZrH2a__header-container",
  "header-wrapper": "Auth-module-scss-module__SZrH2a__header-wrapper",
  "icon": "Auth-module-scss-module__SZrH2a__icon",
  "loader-container": "Auth-module-scss-module__SZrH2a__loader-container",
  "login-access-text": "Auth-module-scss-module__SZrH2a__login-access-text",
  "login-text": "Auth-module-scss-module__SZrH2a__login-text",
  "loginButtonContainer": "Auth-module-scss-module__SZrH2a__loginButtonContainer",
  "loginCard": "Auth-module-scss-module__SZrH2a__loginCard",
  "loginHeading": "Auth-module-scss-module__SZrH2a__loginHeading",
  "provider-text": "Auth-module-scss-module__SZrH2a__provider-text",
});
